import { render, staticRenderFns } from "./ValidateDomain.vue?vue&type=template&id=ef4e06f8"
import script from "./ValidateDomain.vue?vue&type=script&lang=js"
export * from "./ValidateDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports